import { DefaultAction } from './default-action.enum';

export enum UniqueReportActions {}

export const ReportAction = {
  ...DefaultAction,
  ...UniqueReportActions,
};
